module.exports = __webpack_public_path__ + "static/img/role-de.3a0279e.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/layer3/role-4/role-de.png
// module id = gGWm
// module chunks = 1